module.exports = __webpack_public_path__ + "static/media/googleButton.bca38f10.svg";